var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 2.29102L4.37 8.21802C4.32309 8.26498 4.25937 8.29125 4.193 8.29102H2C0.89543 8.29102 0 9.18645 0 10.291V13.705C0 14.8096 0.89543 15.705 2 15.705H4.193C4.25949 15.7052 4.32319 15.7318 4.37 15.779L10.3 21.705C10.5864 21.9857 11.0127 22.0683 11.3831 21.9146C11.7535 21.761 11.9964 21.401 12 21V3.00002C11.9979 2.59832 11.7557 2.23683 11.3849 2.08221C11.0142 1.92758 10.5869 2.00982 10.3 2.29102Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.59 4.96601C17.1976 4.58704 16.5739 4.59246 16.1882 4.9782C15.8025 5.36393 15.797 5.98764 16.176 6.38001C17.6672 7.86999 18.505 9.89153 18.505 11.9995C18.505 14.1075 17.6672 16.129 16.176 17.619C15.797 18.0114 15.8025 18.6351 16.1882 19.0208C16.5739 19.4066 17.1976 19.412 17.59 19.033C19.4564 17.1681 20.505 14.6379 20.505 11.9995C20.505 9.36112 19.4564 6.83091 17.59 4.96601Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.041 2.43403C19.6486 2.05506 19.0249 2.06048 18.6392 2.44621C18.2534 2.83195 18.248 3.45565 18.627 3.84803C23.1192 8.35284 23.1192 15.6432 18.627 20.148C18.367 20.3991 18.2628 20.7709 18.3543 21.1205C18.4458 21.4702 18.7189 21.7432 19.0685 21.8347C19.4181 21.9262 19.7899 21.822 20.041 21.562C25.3134 16.276 25.3134 7.72007 20.041 2.43403Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.141 7.50002C14.8886 7.24708 14.5204 7.14801 14.1751 7.24013C13.8299 7.33225 13.56 7.60156 13.4671 7.94663C13.3743 8.29169 13.4726 8.66008 13.725 8.91302C15.4259 10.6215 15.4259 13.3835 13.725 15.092C13.4468 15.339 13.3286 15.7201 13.4184 16.0811C13.5081 16.4422 13.7909 16.7236 14.1524 16.8115C14.5139 16.8995 14.8944 16.7795 15.14 16.5C17.6156 14.0109 17.6161 9.98968 15.141 7.50002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.c05c890a.svg";
export { ForwardRef as ReactComponent };